var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPresentationAccessDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 15.625C67.9 15.625 82.6313 29.3813 84.2157 46.875H96.7157C95.0969 22.4844 74.7938 3.125 50 3.125C25.2063 3.125 4.90317 22.4844 3.28442 46.875H15.7844C17.3688 29.3813 32.1 15.625 50 15.625Z",
    fill: "#FC3165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84.375C32.1 84.375 17.3688 70.6187 15.7844 53.125H3.28442C4.90317 77.5156 25.2063 96.875 50 96.875C74.7938 96.875 95.0969 77.5156 96.7157 53.125H84.2157C82.6313 70.6187 67.9 84.375 50 84.375Z",
    fill: "#FC3165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 39.0625H45.3125V73.4375H54.6875V39.0625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 26.5625H45.3125V35.9375H54.6875V26.5625Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPresentationAccessDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-presentation-access-dark.8799ece3db9b54fc3c280845294c4aa2.svg";